import * as React from 'react';
import type { ComboSelectorPartialBaseProps } from '../../types';
import { Select } from '~/Partials/Select/Select';
import styles from './ComboSelectorDropdown.module.css';

type ComboSelectorDropdownProps = ComboSelectorPartialBaseProps;

export const ComboSelectorDropdown: React.FC<ComboSelectorDropdownProps> = props => {
    const { labelId, onChange, options, colorVariant, currentValue } = props;

    const getSelectVariant = () => {
        switch (colorVariant) {
            case 'dark':
                return 'dark';
            case 'light':
                return 'light';
            case 'greySelectDarkButtons':
                return 'greyOutline';
            default:
                return undefined;
        }
    };

    return (
        <Select
            className={styles.ComboSelectorDropdown}
            onChange={onChange}
            options={options}
            value={currentValue}
            variant={getSelectVariant()}
            aria-describedby={labelId}
        />
    );
};
